// FICHIER : frontend/src/pages/CommentCaMarche.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BRAND } from '../constants/brand';
import Logo from '../components/Logo';
import NavLogo from '../components/NavLogo';

const IconArrow = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>);

const STEPS = [
  {
    n: '01',
    titre: 'Creez votre compte entreprise',
    desc: "Inscrivez-vous en 30 secondes avec le nom de votre entreprise, votre email et un mot de passe. Aucune carte bancaire requise, aucun engagement.",
    details: 'Vous accedez immediatement a votre tableau de bord avec toutes les fonctionnalites disponibles.',
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>),
  },
  {
    n: '02',
    titre: 'Construisez votre marque employeur',
    desc: "Repondez a quelques questions sur votre entreprise — mission, valeurs, culture, avantages. L'IA genere votre ADN employeur complet en moins de 10 minutes.",
    details: 'Vous obtenez : mission, vision, EVP, pitch entreprise, promesse employeur et accroche page carriere.',
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>),
  },
  {
    n: '03',
    titre: 'Publiez vos offres d\'emploi',
    desc: "Remplissez un formulaire simple — titre, salaire, modalite, competences. L'IA genere une annonce complete, optimisee et prete a publier en quelques secondes.",
    details: 'Chaque offre est automatiquement visible sur la page publique des opportunites.',
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>),
  },
  {
    n: '04',
    titre: 'L\'IA conduit les entretiens',
    desc: "Les candidats passent un entretien structure en 4 phases : profilage, comportemental, technique et cognitif. 20 questions adaptatives, 100% autonome.",
    details: 'Vous n\'intervenez pas. L\'IA s\'adapte en temps reel aux reponses du candidat.',
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>),
  },
  {
    n: '05',
    titre: 'Recevez vos rapports et decidez',
    desc: "Pour chaque candidat, vous recevez un rapport complet : score global, scores par phase, points forts, vigilances, et recommandation recruteur avec questions pour l'appel.",
    details: 'Vous n\'avez plus qu\'a appeler les meilleurs profils. La decision vous appartient, eclairee par les donnees.',
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>),
  },
];

export default function CommentCaMarche() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'DM Sans,sans-serif' }}>

      {/* NAV */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: isMobile ? '0 20px' : '0 64px', height: 68, background: 'var(--nav-bg)', borderBottom: '1px solid var(--border)' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}><NavLogo/></button>
        {!isMobile && (
          <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 32 }}>
            <span onClick={() => navigate('/fonctionnalites')} style={{ color: 'var(--muted)', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>Fonctionnalites</span>
            <span style={{ color: 'var(--text)', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Comment ca marche</span>
            <span onClick={() => navigate('/contact')} style={{ color: 'var(--muted)', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>Contact</span>
          </div>
        )}
        <span onClick={() => navigate('/entreprise')} style={{ background: 'var(--accent)', color: '#fff', padding: isMobile ? '8px 16px' : '9px 22px', borderRadius: 8, fontSize: isMobile ? 12 : 13, fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer', whiteSpace: 'nowrap' }}>
          {isMobile ? 'Espace entreprise' : 'Creer ma marque employeur'} <IconArrow/>
        </span>
      </nav>

      {/* HERO */}
      <section style={{ padding: isMobile ? '48px 20px 32px' : '72px 64px 48px', maxWidth: 1240, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: 'var(--accent2)', fontSize: 11, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>
          <span style={{ width: 24, height: 1, background: 'var(--accent2)', display: 'inline-block' }}/> Processus
        </div>
        <h1 style={{ fontFamily: 'Syne,sans-serif', fontSize: isMobile ? 'clamp(26px,7vw,36px)' : 'clamp(28px,3vw,42px)', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-1.5px', maxWidth: 700, margin: '0 auto 16px' }}>
          Comment ca marche
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: isMobile ? 15 : 17, maxWidth: 550, margin: '0 auto', lineHeight: 1.7 }}>
          De l'inscription a la decision finale, tout est guide par l'intelligence artificielle. Vous n'avez qu'a suivre 5 etapes simples.
        </p>
      </section>

      {/* ETAPES */}
      <section style={{ padding: isMobile ? '0 20px 48px' : '0 64px 80px', maxWidth: 800, margin: '0 auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {STEPS.map((s, i) => (
            <div key={s.n} style={{ display: 'flex', gap: isMobile ? 16 : 28, position: 'relative' }}>

              {/* Ligne verticale + numero */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, width: isMobile ? 48 : 64 }}>
                <div style={{ width: isMobile ? 48 : 64, height: isMobile ? 48 : 64, borderRadius: '50%', background: 'var(--accent)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Syne,sans-serif', fontSize: isMobile ? 16 : 20, fontWeight: 800, flexShrink: 0, position: 'relative', zIndex: 1 }}>
                  {s.n}
                </div>
                {i < STEPS.length - 1 && (
                  <div style={{ width: 2, flex: 1, background: 'var(--border)', minHeight: 32 }}/>
                )}
              </div>

              {/* Contenu */}
              <div style={{ paddingBottom: i < STEPS.length - 1 ? 32 : 0, flex: 1 }}>
                <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: isMobile ? '20px 16px' : '28px 24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                    <div style={{ color: 'var(--accent2)' }}>{s.icon}</div>
                    <h3 style={{ fontFamily: 'Syne,sans-serif', fontSize: isMobile ? 16 : 18, fontWeight: 700, margin: 0 }}>{s.titre}</h3>
                  </div>
                  <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7, margin: '0 0 12px' }}>{s.desc}</p>
                  <div style={{ fontSize: 13, color: 'var(--text)', background: 'var(--accent-08)', borderRadius: 8, padding: '12px 14px', lineHeight: 1.6 }}>
                    {s.details}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: isMobile ? '40px 20px' : '60px 20px', textAlign: 'center', borderTop: '1px solid var(--border)' }}>
        <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: 'clamp(20px,2.5vw,30px)', fontWeight: 800, letterSpacing: '-1px', marginBottom: 14 }}>
          Pret a commencer ?
        </h2>
        <p style={{ color: 'var(--muted)', fontSize: isMobile ? 14 : 16, marginBottom: 28 }}>
          Rejoignez plus de 180 entreprises qui font confiance a {BRAND.name}.
        </p>
        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 12, justifyContent: 'center', alignItems: 'center' }}>
          <span onClick={() => navigate('/entreprise')} style={{ background: 'var(--accent)', color: '#fff', padding: '14px 28px', borderRadius: 10, fontSize: 15, fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
            Creer ma marque employeur <IconArrow/>
          </span>
          <span onClick={() => navigate('/offres')} style={{ background: 'transparent', color: 'var(--text)', padding: '14px 28px', borderRadius: 10, fontSize: 15, fontWeight: 500, border: '1px solid var(--border)', display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
            Voir les offres
          </span>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ borderTop: '1px solid var(--border)', padding: isMobile ? '28px 20px' : '36px 64px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'center', alignItems: 'center', gap: 40, color: 'var(--muted)', fontSize: 13, textAlign: isMobile ? 'center' : 'left' }}>
        <Logo height={28}/>
        <div>&copy; {BRAND.year} {BRAND.name}</div>
      </footer>
    </div>
  );
}
